export default __webpack_public_path__ + "static/O0032-af8a95845f1a5d6f06d9b7c6b0d9e133.png";